import React from "react";
const petals = [0, 45, 90, 135, 180, 225, 270, 315];
export function Daisy({
  className = ""
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 40 40" className={className} aria-hidden="true" data-id="element-80" data-mp="2ipi88mzmf68b">
      {petals.map(r => <ellipse key={r} cx="20" cy="9.5" rx="5" ry="8.5" fill="#FFFFFF" stroke="#F1D7A6" strokeWidth="1" transform={`rotate(${r} 20 20)`} data-id="element-81" data-mp="2dwp523jsw5yc" />)}
      <circle cx="20" cy="20" r="6" fill="#FFC93C" stroke="#F7941D" strokeWidth="1" data-id="element-82" data-mp="1zys3stuejbdc" />
    </svg>;
}